
import EnterTrailerCard from '@/components/EnterTrailerCard.vue';
import { defineComponent } from 'vue';

export default defineComponent({
    components: {
        EnterTrailerCard,
    },
    data: (): {
        backButtonHidden: boolean;
    } => {
        return {
            backButtonHidden: false,
        };
    },
    methods: {
        navigateBack() {
            this.$router.back();
        },
        hideBackButton(hide: boolean) {
            this.backButtonHidden = hide;
        },
    },
});
